import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.875 5.5h2.063v-.687a1.376 1.376 0 0 0-1.375-1.375H3.438a1.377 1.377 0 0 0-1.376 1.374V5.5h2.063a.688.688 0 1 1 0 1.375H2.063v8.25h2.062a.687.687 0 1 1 0 1.375H2.063v.688a1.377 1.377 0 0 0 1.374 1.375h15.126a1.376 1.376 0 0 0 1.375-1.375V16.5h-2.063a.687.687 0 1 1 0-1.375h2.063v-8.25h-2.063a.687.687 0 0 1 0-1.375m-8.594 11H7.562a.687.687 0 1 1 0-1.375h1.72a.687.687 0 1 1 0 1.375m0-9.625H7.562a.688.688 0 1 1 0-1.375h1.72a.688.688 0 1 1 0 1.375m5.156 9.625H12.72a.687.687 0 1 1 0-1.375h1.719a.687.687 0 1 1 0 1.375m0-9.625H12.72a.687.687 0 1 1 0-1.375h1.719a.687.687 0 0 1 0 1.375"
    }, null, -1)
  ])))
}
export default { render: render }